import * as XLSX from 'xlsx'
import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'

/**
 * Utilidades de exportación de tablas (Excel / PDF) reutilizables.
 *
 * columns: [{ key, label, format? }]
 *   - key:    clave del campo en la fila
 *   - label:  cabecera a mostrar en el export
 *   - format: (row) => valor  (opcional, para celdas derivadas: fechas, estado, etc.)
 * rows: array de objetos (filas a exportar)
 */

// Construye cabecera + matriz de valores a partir de columnas y filas.
function buildMatrix(columns, rows) {
  const header = columns.map(c => c.label)
  const body = (rows || []).map(row => columns.map(c => {
    const val = c.format ? c.format(row) : row[c.key]
    return val === null || val === undefined ? '' : val
  }))
  return { header, body }
}

export function exportToExcel(columns, rows, filename = 'export') {
  const { header, body } = buildMatrix(columns, rows)
  const ws = XLSX.utils.aoa_to_sheet([header, ...body])
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Datos')
  XLSX.writeFile(wb, `${filename}.xlsx`)
}

export function exportToPdf(columns, rows, { filename = 'export', title = '' } = {}) {
  const { header, body } = buildMatrix(columns, rows)
  // Apaisado cuando hay muchas columnas para que quepan.
  // eslint-disable-next-line new-cap
  const doc = new jsPDF({ orientation: columns.length > 6 ? 'landscape' : 'portrait' })

  if (title) {
    doc.setFontSize(14)
    doc.text(title, 14, 16)
  }

  autoTable(doc, {
    head: [header],
    body: body.map(r => r.map(v => String(v))),
    startY: title ? 22 : 14,
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [0, 168, 107] }, // verde corporativo MSC
    alternateRowStyles: { fillColor: [245, 245, 245] },
  })

  doc.save(`${filename}.pdf`)
}
